import { render, staticRenderFns } from "./skill-mobile.vue?vue&type=template&id=ec25845a&scoped=true&"
import script from "./skill-mobile.vue?vue&type=script&lang=js&"
export * from "./skill-mobile.vue?vue&type=script&lang=js&"
import style0 from "./skill-mobile.vue?vue&type=style&index=0&id=ec25845a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec25845a",
  null
  
)

export default component.exports